@if (formData.formGroup) {
  <div class="input-wrapper" [formGroup]="formData.formGroup">
    @if (formData.label) {
      <label class="label">
        {{ formData.label }}
      </label>
    }

    <div class="kv-box">
      @for (entry of entries; track entry.key) {
        <div class="kv-row">
          <div class="kv-key readonly-like">{{ entry.key }}</div>

          <input
            class="kv-value"
            type="text"
            [value]="entry.value"
            [readonly]="formData.readonly || false"
            (input)="updateEntryValue(entry.key, $any($event.target).value); onInput($event)" />

          @if (!formData.readonly) {
            <button
              type="button"
              class="kv-remove"
              (click)="removeEntry(entry.key)">
              Entfernen
            </button>
          }
        </div>
      }

      @if (!formData.readonly) {
        <div class="kv-row kv-row--new">
          @if (usesPredefinedKeys) {
            <p-select [options]="availableKeys"
                      (onChange)="draftKey = $event.value;"
                      class="w-full kv-key" />
          } @else {
            <input
              class="kv-key"
              type="text"
              [placeholder]="formData.placeholder || 'Key'"
              [value]="draftKey"
              (input)="draftKey = $any($event.target).value; onInput($event)" />
          }

          <input
            class="kv-value"
            type="text"
            placeholder="Wert"
            [value]="draftValue"
            (input)="draftValue = $any($event.target).value; onInput($event)"
            (keydown.enter)="addEntry()" />

          <button
            type="button"
            class="kv-add"
            (click)="addEntry()">
            Hinzufügen
          </button>
        </div>
      }
    </div>
  </div>
}

@if (formData.infoText) {
  <p class="message info">
    {{ formData.infoText }}
  </p>
}